import React, { useContext } from "react";
import { Spin, Alert } from "antd";
import ApplicationsTable from "./components/ApplicationsTable";
import useLandlordApplications from "./hooks/useApplications";
import { UserContext } from "../../../context/UserContext";

export default function ApplicationsPage() {
  const { user } = useContext(UserContext);
  const landlordUid = user?.uid;

  const { rows, loading, error } = useLandlordApplications(landlordUid);

  if (!landlordUid)
    return <Alert type="warning" message="Please sign in as a landlord." />;

  if (error) {
    return (
      <Alert
        type="error"
        message="Failed to load applications"
        description={String(error)}
      />
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <Spin spinning={loading} tip="Loading applications...">
        <ApplicationsTable data={rows} loading={loading} />
      </Spin>
    </div>
  );
}
